module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"error-msg":"Diese Seite wurde nicht gefunden.","btn-go-home":"Home"},"fr":{"error-msg":"Cette page n’a pas été trouvée.","btn-go-home":"Accueil"},"it":{"error-msg":"Questa pagina non è stata trovata.","btn-go-home":"Home"}}')
  delete Component.options._Ctor
}
